import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-home-content-box',
  templateUrl: './home-content-box.component.html',
  styleUrls: ['./home-content-box.component.scss']
})
export class HomeContentBoxComponent implements OnInit {

  @Input() color ?: string;
  @Input() title ?: string;
  @Input() text ?: string;
  @Input() route ?: string;

  constructor() {
  }

  ngOnInit(): void {
    document.getElementById('hola');
  }

}
